import { useState, useEffect } from "react";
import Button from "../button/Button";
import { useNavigate } from "react-router-dom";
import ApiErrorPage from "../ApiErrorPage/ApiError";
import styles from "./Homepage.module.css";
import { useLocation } from "react-router-dom";
import ConnectorContainer from "../connectorContainer/ConnectorContainer";
import Error404 from "../404Error/404Error";

const Homepage = () => {
  const [cardclicked, setCardClicked] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [connectorid, setConnectorid] = useState(null);
  const [dispalyid, setDisplayid] = useState(null);
  const [chargerId, setChargerId] = useState(null);
  const [noToken, setNoToken] = useState(false);
  const [chargingInProgressFirstScreen, setChargingInProgressFirstScreen] =
    useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [selectedConnector, setSelectedConnector] = useState({
    containerIndex: null,
    connectorIndex: null,
  });

  let timeoutFirstScreen = null;
  const backSession = sessionStorage.getItem("cameFromSocScreen");

  const InitialFetchData = async () => {
    setChargingInProgressFirstScreen(false);
    setError(null);
    const access_token = searchParams.get("token");
    const station_id = searchParams.get("station_id");

    if (!access_token || backSession === "true") {
      setNoToken(true);
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}station/everest/v1/station-detail`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${access_token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ station_id: station_id }),
        }
      );

      const data = await response.json();

      if (
        data?.meta?.status_code === 4000 ||
        data?.meta?.status_code === 1001 ||
        data?.meta?.status_code === 4003
      ) {
        setNoToken(true);
        return;
      }
      setData(data);
    } catch (err) {
      console.log("Error Getting Data", err);
    }
  };

  const ChargeSessionStartCommand = async () => {
    const etn_no = searchParams.get("etn_no");
    const auth_ref = searchParams.get("auth_ref");
    const req_units = searchParams.get("req_units");
    setChargingInProgressFirstScreen(true);
    const access_token = searchParams.get("token");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}transaction/everest/v1/estimate-price?connector_id=${connectorid}&vehicle_id=3&units=${req_units}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`,
          },
        }
      );

      const chargingData = await response.json();

      if (
        chargingData?.meta?.status_code === 3001 ||
        chargingData?.meta?.status_code === 1001
      ) {
        setError(true);
        return;
      }

      if (chargingData?.meta?.status_code === 1000) {
        const startChargeResposne = await fetch(
          `${process.env.REACT_APP_CHARGE_CONTROL}api/v1/charging/remote-start`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${access_token}`,
            },
            body: JSON.stringify({
              vehicle_id: parseInt(process.env.REACT_APP_VEHICLE_ID),
              discount_id: 0,
              metric_flag: "units",
              metric_value: parseInt(req_units),
              connector_id: dispalyid,
              charger_id: chargerId,
              amount: parseInt(chargingData?.data?.estimated_price),
              source: "everest-webapp",
              user_id: process.env.REACT_APP_USER_ID,
              user_vehicle_id: parseInt(process.env.REACT_APP_USER_VEHICLE_ID),
              etn_no: etn_no,
              auth_ref: auth_ref,
            }),
          }
        );

        const startChargeData = await startChargeResposne.json();

        if (startChargeData?.meta?.status_code === 1000) {
          timeoutFirstScreen = setTimeout(() => {
            setChargingInProgressFirstScreen(false);
            navigate(
              `/get-charging-soc?booking_id=${startChargeData?.data?.booking_id}&token=${access_token}`
            );
          }, 2500);
        } else {
          setChargingInProgressFirstScreen(false);
          setError(true);
        }
      }
    } catch (err) {
      setError(err);
      console.log("Error Getting Soc", err);
    }
  };

  useEffect(() => {
    InitialFetchData();
    return () => {
      clearTimeout(timeoutFirstScreen);
    };
  }, []);

  if (noToken) {
    return <Error404 />;
  }

  return error ? (
    <ApiErrorPage
      setError={setError}
      setCardClicked={setCardClicked}
      setSelectedConnector={setSelectedConnector}
      InitialFetchData={InitialFetchData}
      setConnectorid={setConnectorid}
      setChargerId={setChargerId}
      setDisplayid={setDisplayid}
      setChargingInProgressFirstScreen={setChargingInProgressFirstScreen}
    />
  ) : chargingInProgressFirstScreen ? (
    <div className={styles.imageContainer}>
      <div>
        <span className={styles.heading}>Please wait, initiating charging</span>
        <img src="/assets/LoaderGif.gif" className={styles.pinImage} />
        <span className={styles.description}>
          Please do not go back or switch apps, trying to connect to the charger
        </span>
      </div>
    </div>
  ) : (
    <div className={styles.container}>
      <div
        className={styles.headImage}
        style={{
          backgroundImage: `url("${
            data?.data?.station_banner
              ? data.data.station_banner.trim()
              : "/assets/HeadImage.svg"
          }")`,
        }}
      >
        <div className={styles.headButton}>
          <img
            src="/assets/Dialer.svg"
            onClick={() => (window.location.href = "tel:+918070743743")}
          />
        </div>
      </div>

      <div className={styles.stationOuter}>
        <p className={styles.stationName}>{data?.data?.station_name}</p>
        <div className={styles.stationContainer}>
          {data?.data?.plugin_details?.map((item, containerIndex) => (
            <ConnectorContainer
              key={containerIndex}
              connector_types={data?.data?.connector_types}
              OuterCard={item}
              containerIndex={containerIndex}
              selectedConnector={selectedConnector}
              setSelectedConnector={setSelectedConnector}
              setCardClicked={setCardClicked}
              setConnectorid={setConnectorid}
              setChargerId={setChargerId}
              setDisplayid={setDisplayid}
            />
          ))}
        </div>
      </div>

      <div className={styles.buttonContainer}>
        {cardclicked ? (
          <Button
            className="enableConnectorButton"
            disabled={false}
            value="Charge Now"
            onClick={ChargeSessionStartCommand}
          />
        ) : (
          <Button
            className="disableConnectorButton"
            disabled={true}
            value="Select a connector"
          />
        )}
      </div>
    </div>
  );
};

export default Homepage;
